<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><b>CONTENTS</b></p>
<p class="toc"><a href="#/foreword">Foreword, by Pat Williams</a></p>
<p class="toc"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">1. The Early Years: Barnstorming and Boomtowns</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. Montanans in the Majors</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. Big Leaguers Who Adopted Big Sky Country</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. The Pioneer League: Pipeline to the Majors</span></p>
<p class="toc1"><span href="#/author" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?cf9fab40